export default __webpack_public_path__ + "static/14_25-cbb64a9bcc7aaf73a483b0ec5737de43.png";